import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import newOcLogo from '../../assets/images/cpi-logo.png'
import newBg from '../../assets/images/bg-images/new-bg-25.jpg'
import { TotpInput } from '../../components/TotpInput'

const bgStyle = {
  backgroundImage: `url(${newBg})`,
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed',
  backgroundPosition: 'center',
  height: '100vh',
  overflow: 'hidden',
}
export default function OtpScreen({ onSubmit, onReset }) {
  const { t } = useTranslation()
  return (
    <div
      style={bgStyle}
      className="auth-wrapper aut-bg-img-side container-fluid d-flex align-items-center justify-content-center"
    >
      <div className="auth-content text-center">
        <div style={{ marginBottom: '50px' }}>
          <img src={newOcLogo} alt="logo" width={360} />
        </div>
        <h3 className="mb-4">{t('login.login')}</h3>
        <TotpInput trigger={onSubmit} />
        <p className="mt-3 text-muted">
          {t('login.back_to')}{' '}
          <Link to="/auth/sigin" onClick={onReset}>
            {t('Login')}
          </Link>
        </p>
      </div>
    </div>
  )
}

